import { SelectOption } from '@globaleris/ui.library'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import {
  formRequestRemit,
  formRequestReportFilesByGroups
} from '../../../../pages/regulatoryReports/regulatoryReports.mapper'
import {
  GenerateRegulatoryReportAPIRequest,
  GenerateRegulatoryReportRequest,
  GenerateReportRequest,
  GenerateReportRequestTable1,
  regulatoryReportDownloadCard,
  regulatoryReportResponseModel,
  remitLngResponseModel,
  remitStorageResponseModel,
  remitTableResponseModel
} from '../../../../pages/regulatoryReports/regulatoryReports.Model'
import { getAppConfigurationValue, getUserName } from '../../../../redux/helpers'
import AxiosInstance from '../../../http-config'
import { EnumGrupoDocumento, EnumTipoOperacion } from '../../../oData/enums'

export const fetchRegulatoryReportsOperation = async (
  operationTypes: EnumTipoOperacion[],
  startDate: Date,
  endDate: Date
): Promise<Array<remitTableResponseModel>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let request = formRequestRemit(startDate, endDate, operationTypes)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/RegulatoryReports/FetchRemitTableOperations`,
    request
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const fetchRegulatoryReportsPosition = async (
  operationTypes: EnumTipoOperacion[],
  startDate: Date,
  endDate: Date
): Promise<Array<remitTableResponseModel>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let request = formRequestRemit(startDate, endDate, operationTypes)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/RegulatoryReports/FetchRemitTablePositions`,
    request
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const fetchRegulatoryReportsStorage = async (
  operationTypes: EnumTipoOperacion[],
  startDate: Date,
  endDate: Date,
  idElemLog: number | undefined
): Promise<Array<remitStorageResponseModel>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let request = formRequestRemit(startDate, endDate, operationTypes, idElemLog)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/RegulatoryReports/FetchRemitStorage`,
    request
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const fetchRegulatoryReportsLng = async (
  operationTypes: EnumTipoOperacion[],
  startDate: Date,
  endDate: Date
): Promise<Array<remitLngResponseModel>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let request = formRequestRemit(startDate, endDate, operationTypes)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/RegulatoryReports/FetchRemitLngActivity`,
    request
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const generateSCT1Report = async (
  request: GenerateReportRequestTable1
): Promise<Array<remitLngResponseModel>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/RegulatoryReports/GenerateSCT1Report`,
    request
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const generateNonSCT2Report = async (
  request: GenerateReportRequest
): Promise<Array<remitLngResponseModel>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/RegulatoryReports/GenerateNonSCT2Report`,
    request
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const generateStorageParticipantReport = async (
  request: GenerateReportRequest
): Promise<Array<remitLngResponseModel>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/RegulatoryReports/GenerateSPAReport`,
    request
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const generateLngReport = async (
  request: GenerateReportRequest
): Promise<Array<remitLngResponseModel>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/RegulatoryReports/GenerateLngReport`,
    request
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const getRRMs = async (balanceZone: number): Promise<Array<SelectOption>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/RegulatoryReports/GetRRM?balanceZone=${balanceZone}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const fetchReportFiles = async (
  balanceZoneId: number,
  companyId: number,
  documentType: number
): Promise<Array<regulatoryReportDownloadCard>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/RegulatoryReports/FetchReportFiles?balanceZone=${balanceZoneId}&companyId=${companyId}&documentType=${documentType}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const fetchReportFilesByGroups = async (
  groupsDocument: EnumGrupoDocumento[]
): Promise<Array<regulatoryReportDownloadCard>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let request = formRequestReportFilesByGroups(groupsDocument)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/RegulatoryReports/FetchReportFilesByGroups`,
    request
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const fetchRegulatoryReportsPowerCommodity = async (
  operationTypes: EnumTipoOperacion[],
  startDate: Date,
  endDate: Date
): Promise<Array<remitTableResponseModel>> => {
  return []
}

export const generateRegulatoryReportsPowerCommodity = async (
  request: GenerateRegulatoryReportRequest
): Promise<Array<regulatoryReportResponseModel>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/RegulatoryReports/GenerateRegulatoryReporting`,
    request
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const generateRegulatoryReportsPowerCommodityAsync = async (
  request: GenerateRegulatoryReportAPIRequest
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  AxiosInstance.post(
    `${apiSuffixUrl}/api/RegulatoryReports/GenerateRegulatoryReportingEventGrid`,
    request,
    {
      headers: {
        //'x-asr-connection-request-id': connectionId
        'x-asr-user-request-id': getUserName()
      }
    }
  )

  return new Promise((resolve, reject) => {
    resolve({ success: true })
  })
}
